import type { S3ObjectForPrint } from '../print-types'

import { pageSize } from './print-style'

import type { PrintPage } from '@/components/app/print-page-plan'

// v1 apps/frontend/client/src/components/MillsheetPrintForm/PrintS3Object.tsx の移植（そのまま）。
// PDF をそのまま印刷で扱うのが難しいため、画像に変換済みのサムネイルを使う
export function PrintS3Object({
  s3Object,
  pageNumber,
}: {
  s3Object: { isLandscape: boolean; imageUrls: string[] } & Pick<S3ObjectForPrint, 'id'>
  pageNumber: number | null
}) {
  return (
    <>
      {s3Object.imageUrls.map((imageUrl) => {
        return (
          <div
            key={imageUrl}
            className="pdf-container"
            style={{
              ...pageSize,
              position: 'relative',
            }}
          >
            <img
              src={imageUrl}
              alt="Displayed content"
              style={{
                // 縦横比を維持したまま、ページサイズに合わせて最大表示
                width: s3Object.isLandscape ? undefined : '100%',
                height: s3Object.isLandscape ? '100%' : undefined,
                maxHeight: s3Object.isLandscape ? pageSize.width : pageSize.height,
                maxWidth: s3Object.isLandscape ? pageSize.height : pageSize.width,
                // 元画像のアスペクト比に応じて回転させる（横長の画像を、縦A4に合わせてそのまま表示すると小さく表示されるため）
                marginLeft: s3Object.isLandscape ? pageSize.width : undefined,
                transform: s3Object.isLandscape ? 'rotate(90deg)' : 'none',
                transformOrigin: 'top left',
              }}
            />
            {/* v1 からの逐語移植のため直接比較のまま残す */}
            {pageNumber !== null && (
              <div
                style={{
                  position: 'absolute',
                  // 横向きA4を90度回転させている場合、元の右下は回転後の左下になる
                  bottom: '5mm',
                  ...(s3Object.isLandscape ? { left: '5mm' } : { right: '5mm' }),
                  fontSize: '8pt',
                  color: '#666',
                  fontFamily: 'Arial, sans-serif',
                  zIndex: 10,
                  // ミルシート内容と被らないように、背景を半透明の白にする
                  backgroundColor: 'rgba(255, 255, 255, 0.7)',
                  padding: '1mm 2mm',
                  borderRadius: '2px',
                  // 横向きA4の場合、数字自体も90度回転させる（元の向きを保つため）
                  transform: s3Object.isLandscape ? 'rotate(90deg)' : 'none',
                  transformOrigin: 'center',
                }}
              >
                {pageNumber}
              </div>
            )}
          </div>
        )
      })}
    </>
  )
}

export function PrintPlannedPage({ page }: { page: PrintPage }) {
  return (
    <div
      className="pdf-container"
      data-testid="print-physical-page"
      data-page-no={page.pageNo}
      data-page-kind={page.kind}
      data-millsheet-id={page.millsheetId}
      data-s3-object-id={page.s3ObjectId}
      data-source-page-index={page.sourcePageIndex}
      style={{
        ...pageSize,
        position: 'relative',
      }}
    >
      <img
        src={page.imageUrl}
        alt={`${page.kind === 'millsheet' ? 'ミルシート' : '添付資料'} 番号 ${page.pageNo}`}
        style={{
          width: page.isLandscape ? undefined : '100%',
          height: page.isLandscape ? '100%' : undefined,
          maxHeight: page.isLandscape ? pageSize.width : pageSize.height,
          maxWidth: page.isLandscape ? pageSize.height : pageSize.width,
          marginLeft: page.isLandscape ? pageSize.width : undefined,
          transform: page.isLandscape ? 'rotate(90deg)' : 'none',
          transformOrigin: 'top left',
        }}
      />
      <div
        data-testid="print-physical-page-number"
        style={{
          position: 'absolute',
          bottom: '5mm',
          ...(page.isLandscape ? { left: '5mm' } : { right: '5mm' }),
          fontSize: '8pt',
          color: '#666',
          fontFamily: 'Arial, sans-serif',
          zIndex: 10,
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          padding: '1mm 2mm',
          borderRadius: '2px',
          transform: page.isLandscape ? 'rotate(90deg)' : 'none',
          transformOrigin: 'center',
        }}
      >
        {page.pageNo}
      </div>
    </div>
  )
}
